export var MappingCodeType;
(function (MappingCodeType) {
    MappingCodeType["CRQLAR_FOOD_TYPE"] = "CRQLAR_FOOD_TYPE";
    MappingCodeType["CRQLAR_FOOD_ALLERGY"] = "CRQLAR_FOOD_ALLERGY";
    MappingCodeType["CRQLAR_TRAVELING_WITH_PET"] = "CRQLAR_TRAVELING_WITH_PET";
    MappingCodeType["CRQLAR_INTERESTS"] = "CRQLAR_INTERESTS";
    MappingCodeType["CRQLAR_AI_GENERATED_INTERESTS"] = "CRQLAR_AI_GENERATED_INTERESTS";
    MappingCodeType["CRQLAR_MEDICAL"] = "CRQLAR_MEDICAL";
    MappingCodeType["CRQLAR_PILLOW_TYPE"] = "CRQLAR_PILLOW_TYPE";
    MappingCodeType["CRQLAR_BED_TYPE"] = "CRQLAR_BED_TYPE";
    MappingCodeType["CRQLAR_VIEW_TYPE"] = "CRQLAR_VIEW_TYPE";
    MappingCodeType["CRQLAR_ACCESSIBILITY"] = "CRQLAR_ACCESSIBILITY";
    MappingCodeType["CRQLAR_AMENITIES"] = "CRQLAR_AMENITIES";
    MappingCodeType["CRQLAR_OTHER"] = "CRQLAR_OTHER";
    MappingCodeType["OTA_LOYALTY"] = "OTA_LOYALTY";
    MappingCodeType["OTA_ROOM_AMENITY"] = "OTA_ROOM_AMENITY";
    MappingCodeType["OTA_PAYMENT_FORM"] = "OTA_PAYMENT_FORM";
    MappingCodeType["OTA_HOTEL_CHAIN"] = "OTA_HOTEL_CHAIN";
    MappingCodeType["OTA_PROPERTY_NAME"] = "OTA_PROPERTY_NAME";
    MappingCodeType["OTA_PROPERTY_LOCATION"] = "OTA_PROPERTY_LOCATION";
    MappingCodeType["OTA_PROPERTY_TYPE"] = "OTA_PROPERTY_TYPE";
    MappingCodeType["OTA_PROPERTY_CLASS"] = "OTA_PROPERTY_CLASS";
    MappingCodeType["OTA_PROPERTY_AMENITY"] = "OTA_PROPERTY_AMENITY";
    MappingCodeType["OTA_ROOM_LOCATION"] = "OTA_ROOM_LOCATION";
    MappingCodeType["OTA_BED_TYPE"] = "OTA_BED_TYPE";
    MappingCodeType["OTA_FOOD_SERVICE"] = "OTA_FOOD_SERVICE";
    MappingCodeType["OTA_MEDIA_ENTERTAINMENT"] = "OTA_MEDIA_ENTERTAINMENT";
    MappingCodeType["OTA_PET_INFO"] = "OTA_PET_INFO";
    MappingCodeType["OTA_MEAL"] = "OTA_MEAL";
    MappingCodeType["OTA_RECREATION_SERVICE"] = "OTA_RECREATION_SERVICE";
    MappingCodeType["OTA_BUSINESS_SERVICE"] = "OTA_BUSINESS_SERVICE";
    MappingCodeType["OTA_PERSONAL_SERVICE"] = "OTA_PERSONAL_SERVICE";
    MappingCodeType["OTA_SECURITY_FEATURE"] = "OTA_SECURITY_FEATURE";
    MappingCodeType["OTA_SPECIAL_REQUEST"] = "OTA_SPECIAL_REQUEST";
    MappingCodeType["FOLIO_ROOM_CHARGE"] = "FOLIO_ROOM_CHARGE";
    MappingCodeType["FOLIO_FOOD_AND_BEVERAGE"] = "FOLIO_FOOD_AND_BEVERAGE";
    MappingCodeType["FOLIO_SPA"] = "FOLIO_SPA";
    MappingCodeType["FOLIO_SPORTS"] = "FOLIO_SPORTS";
    MappingCodeType["FOLIO_TAX"] = "FOLIO_TAX";
    MappingCodeType["FOLIO_DISCOUNT"] = "FOLIO_DISCOUNT";
    MappingCodeType["FOLIO_ROOM_SERVICE"] = "FOLIO_ROOM_SERVICE";
    MappingCodeType["FOLIO_OTHER"] = "FOLIO_OTHER";
    MappingCodeType["FOLIO_TOTAL_REVENUE"] = "FOLIO_TOTAL_REVENUE";
    MappingCodeType["FOLIO_MINIBAR"] = "FOLIO_MINIBAR";
    MappingCodeType["FOLIO_BREAKFAST"] = "FOLIO_BREAKFAST";
    MappingCodeType["FOLIO_DINNER"] = "FOLIO_DINNER";
    MappingCodeType["FOLIO_LUNCH"] = "FOLIO_LUNCH";
    MappingCodeType["FOLIO_PHONE"] = "FOLIO_PHONE";
    MappingCodeType["FOLIO_INTERNET"] = "FOLIO_INTERNET";
    MappingCodeType["FOLIO_PARKING"] = "FOLIO_PARKING";
    MappingCodeType["FOLIO_DEPOSIT"] = "FOLIO_DEPOSIT";
    MappingCodeType["FOLIO_PAYMENT"] = "FOLIO_PAYMENT";
})(MappingCodeType || (MappingCodeType = {}));
